import { render } from "./Commerce3.vue?vue&type=template&id=77190fcb"
import script from "./Commerce3.vue?vue&type=script&lang=js"
export * from "./Commerce3.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__